import { Card } from './ui/card';

export const About = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-600 to-yellow-500">Meet</span> Chad Sakers
            </h2>
            <p className="text-xl text-blue-700 font-semibold">First-Time Home Buying Specialist</p>
          </div>

          <Card className="overflow-hidden shadow-2xl border-0">
            <div className="md:flex">
              <div className="md:w-2/5 bg-gradient-to-br from-slate-800 to-blue-900 p-8 flex items-center justify-center">
                <div className="relative">
                  <div className="absolute inset-0 bg-yellow-400 rounded-full blur-2xl opacity-20"></div>
                  <img
                    src="https://customer-assets.emergentagent.com/job_homebuyers-club/artifacts/jx1hpoio_headshot.jpg"
                    alt="Chad Sakers"
                    className="relative rounded-full w-64 h-64 object-cover border-4 border-yellow-400 shadow-2xl"
                  />
                </div>
              </div>
              
              <div className="md:w-3/5 p-8 md:p-12 bg-slate-50">
                <div className="space-y-6">
                  <p className="text-lg text-slate-700 leading-relaxed">
                    Chad Sakers is a dedicated real estate professional specializing in guiding <span className="font-semibold text-blue-700">first-time home buyers</span> through every step of the purchasing process.
                  </p>
                  
                  <p className="text-lg text-slate-700 leading-relaxed">
                    He offers comprehensive support and is equipped with a skilled team that provides proven expertise in <span className="font-semibold text-blue-700">credit repair</span> and securing valuable <span className="font-semibold text-blue-700">down payment assistance programs</span>.
                  </p>
                  
                  <p className="text-lg text-slate-700 leading-relaxed">
                    This integrated approach ensures clients are financially prepared and positioned for a smooth and successful transition into homeownership.
                  </p>

                  <div className="pt-6 border-t border-slate-300">
                    <div className="flex flex-col gap-3">
                      <a href="tel:404-547-4731" className="text-blue-700 hover:text-blue-900 font-semibold transition-colors flex items-center gap-2">
                        <span className="text-yellow-600">📞</span> 404-547-4731
                      </a>
                      <a href="mailto:chad@ntd1stclassrealty.com" className="text-blue-700 hover:text-blue-900 font-semibold transition-colors flex items-center gap-2">
                        <span className="text-yellow-600">✉️</span> chad@ntd1stclassrealty.com
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};
